module.exports = __webpack_public_path__ + "static/img/tab1.db03f520.png";